import { Pipe, PipeTransform } from '@angular/core';
import 'rxjs/add/operator/map';
@Pipe({
  name: 'geolocationdistance'
})
export class GeolocationdistancePipe implements PipeTransform {

  transform(data: any, geolocation: any): any {
	   if (geolocation === undefined || (geolocation.lat === 0.0 &&  geolocation.lon === 0.0)) {
		  return data;
    }else {
      let out = []
      data = this.applyHaversine(data, geolocation);
       out = data.sort( function(a, b) {
          return a['distance'] - b['distance'];
        });
    return out;
    }
  }

  applyHaversine(data, geolocation) {
      data.map((da) => {
       const placeLocation = {
                   lat: da.lat,
                   lng: da.lon,
               };
          da.distance = this.getDistanceBetweenPoints(
                   geolocation,
                   placeLocation,
                   'km'
               ).toFixed(2);
           });
    return data;
  }
  getDistanceBetweenPoints(start, end, units) {
         const R = 6371;
           const lat1 = start.lat;
           const lon1 = start.lon;
           const lat2 = end.lat;
           const lon2 = end.lng;
           const dLat = this.toRad((lat2 - lat1));
           const dLon = this.toRad((lon2 - lon1));
           const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
           Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2)) *
           Math.sin(dLon / 2) *
           Math.sin(dLon / 2);
           const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
           const d = R * c;
          return d;
     }
    toRad(x) {
           return x * Math.PI / 180;
       }
  }
